import React from "react";
import { Button, Modal, Table, Typography } from "antd";
import type { TableColumnsType } from "antd";
import type { QuizWithRecords } from "./quizImpactCheck";

const { Paragraph } = Typography;

interface QuizzesWithRecordsModalProps {
  // Open while there are some to confirm.
  quizzes: QuizWithRecords[] | null;
  onConfirm: () => void;
  onCancel: () => void;
}

const count =
  (key: keyof QuizWithRecords["impact"]) =>
  (_: unknown, quiz: QuizWithRecords) =>
    quiz.impact[key];

const COLUMNS: TableColumnsType<QuizWithRecords> = [
  { title: "Fila", dataIndex: "rowNumber", width: 64 },
  {
    title: "Curso",
    render: (_, quiz) =>
      [quiz.clave, quiz.courseTitle].filter(Boolean).join(" · "),
  },
  { title: "Escuelas", render: count("school_count") },
  { title: "Tareas", render: count("homework_count") },
  { title: "Alumnos", render: count("student_count") },
  { title: "Intentos en curso", render: count("in_flight_attempt_count") },
  {
    title: "Resultados registrados",
    render: count("completed_attempt_count"),
  },
];

/**
 * SCRUM-1581: asked once, before an upload run, about the quizzes it would
 * replace that homework or student attempts outside Emmi's own schools already
 * reach. It only informs: Confirmar uploads every row and replaces those
 * quizzes on the same quiz and resource, Cancelar uploads nothing.
 */
const QuizzesWithRecordsModal: React.FC<QuizzesWithRecordsModalProps> = ({
  quizzes,
  onConfirm,
  onCancel,
}) => (
  <Modal
    open={quizzes !== null}
    title="Hay quizzes con tareas asignadas o intentos registrados"
    onCancel={onCancel}
    width={880}
    destroyOnClose
    footer={[
      <Button key="cancel" onClick={onCancel}>
        Cancelar
      </Button>,
      <Button key="confirm" type="primary" onClick={onConfirm}>
        Confirmar
      </Button>,
    ]}
  >
    <Paragraph type="secondary">
      Si confirmas, se suben todas las filas y estos quizzes se actualizan con
      su YAML y conservan su ID. Las calificaciones ya registradas se conservan,
      pero las respuestas guardadas no se corresponderán con las preguntas
      nuevas y los intentos en curso se calificarán con la versión nueva. Si
      cancelas, no se sube nada.
    </Paragraph>
    <Table
      rowKey="rowNumber"
      size="small"
      columns={COLUMNS}
      dataSource={quizzes ?? []}
      pagination={false}
    />
    <Paragraph type="secondary" style={{ marginTop: 12, marginBottom: 0 }}>
      No se cuentan los registros de Colegio Rincón de Luz, Academia Emmi y Mac
      Test.
    </Paragraph>
  </Modal>
);

export default QuizzesWithRecordsModal;
